"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _styles = require("@material-ui/core/styles");

var _default = (0, _styles.makeStyles)(function (theme) {
  var _root;

  return {
    root: (_root = {
      color: theme.palette.denim[500],
      fontFamily: theme.typography.fontFamilyMedium,
      fontSize: theme.typography.pxToRem(14),
      lineHeight: 1,
      pointerEvents: 'auto',
      '&:empty': {
        margin: 0
      }
    }, (0, _defineProperty2.default)(_root, theme.breakpoints.up(1024), {
      fontSize: theme.typography.pxToRem(16)
    }), (0, _defineProperty2.default)(_root, '&$focused', {
      color: theme.palette.denim[500]
    }), (0, _defineProperty2.default)(_root, '&$error', {
      color: theme.palette.cardinal[500]
    }), (0, _defineProperty2.default)(_root, '&$disabled', {
      color: theme.palette.stainless[700]
    }), _root),
    formControl: {
      marginBottom: theme.spacing(1),
      position: 'relative',
      transform: 'none'
    },
    disabled: {},
    focused: {},
    error: {},
    outlined: {},
    required: {}
  };
}, {
  name: 'PdsInputLabel'
});

exports.default = _default;
